import { render } from "./FooterBar.vue?vue&type=template&id=18236c33"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=18236c33&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__